var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMatters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 64,
    viewBox: "0 0 91 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.425 14.945L1.70499 25.195C1.54779 25.3317 1.42994 25.5079 1.36362 25.7053C1.29729 25.9028 1.2849 26.1144 1.32771 26.3183C1.37052 26.5222 1.46699 26.7109 1.60715 26.865C1.74731 27.0192 1.92608 27.1331 2.12499 27.195L17.395 31.795L85.125 19.185C86.4391 18.9393 87.6376 18.2727 88.5396 17.286C89.4415 16.2992 89.998 15.0458 90.125 13.715C90.345 10.215 89.455 7.25497 88.745 4.33497C88.3765 2.95001 87.4874 1.76082 86.2633 1.01554C85.0392 0.270261 83.5745 0.0264465 82.175 0.334972L13.425 14.945Z",
    fill: "#FE6571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0046 18.5949C53.6786 17.1898 49.0912 16.7796 44.5846 17.3949C43.7846 17.5149 40.6446 17.6449 40.2746 19.8949C39.7846 22.8949 49.0646 24.3749 51.1046 25.0649C47.1046 26.2449 42.4246 28.3949 41.7546 34.8049",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4847 24.5151C29.8347 26.7751 30.1347 31.8251 30.7147 34.5151C31.6347 38.8051 35.3347 43.4251 35.3747 45.3551C35.3747 45.3551 36.0047 44.9451 35.3747 51.6051",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7342 16.3251C51.646 13.1265 52.1094 9.93647 53.1042 6.89514C54.2042 3.89514 56.2742 2.61514 58.5042 2.51514C60.9042 2.41514 64.0442 4.20514 64.7942 11.0751C65.7042 19.4251 61.1342 29.6351 60.7942 38.0251C60.7042 40.5151 61.2942 52.7751 64.8942 62.3951",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9646 4.47494C53.3546 3.40494 51.9646 2.39494 49.7246 3.20494C48.5846 3.62494 45.5846 5.76494 46.0446 16.7649",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9243 3.32506C45.3443 2.74506 42.0443 1.45506 40.7943 4.70506C38.6343 10.3251 39.6043 16.1651 40.7943 18.3951",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5846 4.07499C34.5846 2.70499 29.8546 9.39499 33.4846 18.895C34.4846 21.545 37.3946 21.775 37.7946 21.015",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.635 12.0151C58.1631 14.1489 57.9382 16.3299 57.965 18.5151",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1348 1.51514C81.8148 7.01514 83.5848 13.2151 83.4648 18.9551",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9346 15.335C14.8516 20.6321 16.0905 25.8685 17.6446 31.015",
    stroke: "#092C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3147 22.8853L1.3147 25.5553C1.20103 25.6534 1.11503 25.7795 1.06525 25.9212C1.01546 26.0628 1.00364 26.2151 1.03094 26.3627C1.05825 26.5103 1.12373 26.6483 1.22088 26.7628C1.31803 26.8772 1.44347 26.9643 1.5847 27.0153L5.8047 28.2753L4.3147 22.8853Z",
    fill: "#092C4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.21,
    height: 63.21,
    fill: "white",
    transform: "translate(0.974609 0.185059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMatters);
export default __webpack_public_path__ + "static/media/icon-matters.b75e56d76af9f208130f9a67ff64b33c.svg";
export { ForwardRef as ReactComponent };